import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'parseB2bProgramTicketsName',
    standalone: true,
})
export class ParseB2bProgramTicketsNamePipe implements PipeTransform {

    public transform(value: string): string {
        const arIncludes: string[] = value.split(';');

        if (arIncludes.length > 1) {
            return arIncludes.join('<br/>');
        }

        return value;
    }

}
